import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { BioPanel } from './Bio-Panel';

const doctors = [
    {
        name: 'Jordan R. Rigsby, DMD',
        bio: 'Dr. Jordan Rigsby graduated from Nova Southeastern University with his Doctorate of Dental Medicine after graduating from Florida State University. Since graduating, Dr. Rigsby has worked mindfully and positively to help his community—leaving his patients comfortable, healthy, and satisfied. Dr. Rigsby was raised in the Florida Panhandle and has since returned to Tallahassee because of the beauty of Northern Florida and for the strong community. Dr. Rigsby works hard to remain current with the latest advances in dental technology.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/3-meet-our-doctors/jordan-rigsby-dmd.jpg"
                alt="Jordan R. Rigsby, DMD"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: `Nicholas Kizirian, DMD`,
        bio: 'Dr. Nicholas Kizirian, or “Dr. K,” was born and raised in Tallahassee. After graduating from Florida State University, he went on to earn his Doctorate of Dental Medicine from Nova Southeastern University. Prior to joining First Care Dental Associates in 2017 he practiced in West Florida and Central Florida. Dr. Kizirian believes a commitment to continuing education is essential in order to provide the best advanced care to his patients, and as such he has been an Invisalign provider since 2013, and he earned Fellowship status with the Academy of General Dentistry in 2021. In his spare time, Dr. Kizirian enjoys tinkering with computers, keeping fit at the gym, gardening, and traveling. Dr. Kizirian is excited to have returned to his hometown so that he can remain a part of the community he loves.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/3-meet-our-doctors/nicholas-kizirian-dmd.jpg"
                alt="Nichoolas Kizirian, DMD"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Daniel Sharpstein, DMD',
        bio: 'Dr. Daniel Sharpstein was born and raised in Orlando, Florida. He graduated from Florida State University, after which he attended Nova Southeastern University and received his Doctoral of Dental Medicine in 2013. Upon graduation, he commissioned into the U.S. Army. Dr. Sharpstein served for over seven years, including a one year Advanced Education in General Dentistry residency, and a three year overseas tour in beautiful Bavaria, Germany. He was proud to serve his country, and to take care of our soldiers and their families. Dr. Sharpstein, his wife, Kathryn, and three children are so excited to move back to Florida and become part of the Tallahassee community!',
        image: () => (
            <StaticImage
                className="image"
                src="../images/3-meet-our-doctors/daniel-sharpstein-dmd.jpg"
                alt="Daniel Sharpstein, DMD"
                placeholder="none"
                quality={100}
            />
        ),
    },
];

const DoctorPanelsStyled = styled.footer`
    @media ${theme.device.tablet} {
    }
`;

export const DoctorPanels: React.FC = () => {
    return (
        <DoctorPanelsStyled className="container">
            {doctors.map(doctor => {
                return <BioPanel key={doctor.name} {...doctor} />;
            })}
        </DoctorPanelsStyled>
    );
};
